
import { useState, useEffect } from 'react';
import { subscribeToFirmUpdates } from '../services/firestoreService';
import { FirmUpdate } from '../types';
import { useAuth } from '../context/AuthContext';

export const useFirmUpdates = () => {
  const [updates, setUpdates] = useState<FirmUpdate[]>([]);
  const [loading, setLoading] = useState(true);
  const { firmId } = useAuth();

  useEffect(() => {
    // Fix: pass firmId from context as the first argument to subscribeToFirmUpdates
    const unsub = subscribeToFirmUpdates(firmId || 'hannah-financial-demo', (data) => {
      setUpdates(data);
      setLoading(false);
    });
    return () => unsub();
  }, [firmId]);

  return { updates, loading };
};
